import { InjectionToken } from '@angular/core';

import type { ProductUpdatesEnvironment } from '../../environments/interface';

export const PRODUCT_UPDATES_CONFIG = new InjectionToken<ProductUpdatesConfig>(
  'PRODUCT_UPDATES_CONFIG',
);

export interface ProductUpdatesConfig {
  apiUrl: string;
  baseUrl: string;
  defaultLocale: string;
  availableLocales: string[];
  showTestIds: boolean;
}

export function provideProductUpdatesConfig(environment: ProductUpdatesEnvironment) {
  return {
    provide: PRODUCT_UPDATES_CONFIG,
    useValue: {
      apiUrl: environment.apiUrl,
      baseUrl: environment.baseUrl,
      defaultLocale: environment.i18n.defaultLocale,
      availableLocales: environment.i18n.availableLocales,
      showTestIds: !environment.production,
    } satisfies ProductUpdatesConfig,
  };
}
